import PropTypes from 'prop-types';
import { Link as RouterLink, useParams } from 'react-router-dom';

import { useState, useEffect, useReducer } from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';

// material
import { useTheme } from '@mui/material/styles';
import { Box, Card, Link, Typography, Stack, Grid, Container, Tab, Tabs } from '@mui/material';
import Page from '../../../components/Page';
import { styled } from '@mui/material/styles';
// utils
// components
import LoadingScreen from 'react-loading-screen';

import { LoginRequired } from '../../../layouts/LoginRequired'
import UserProfileForm from './UserProfileForm'

import UserService from '../../../services/user_service'

import { useDispatch } from 'react-redux';
import UserChangePasswordForm from './UserChangePasswordForm';
import UserSubscriptionPage from './UserSubscriptionTab';

const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 92;

const RootStyle = styled('div')({
    display: 'flex',
    minHeight: '100%',
    overflow: 'hidden'
});

const MainStyle = styled('div')(({ theme }) => ({
    flexGrow: 1,
    overflow: 'auto',
    minHeight: '100%',
    paddingTop: APP_BAR_MOBILE + 24,
    paddingBottom: theme.spacing(10),
    [theme.breakpoints.up('lg')]: {
        paddingTop: APP_BAR_DESKTOP + 24,
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2)
    }
}));

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}


export default function UserProfile() {
    // const { app_id } = app_id;
    const params = useParams();
    const [value, setValue] = useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };


    const [isLoading, setIsLoading] = useState(true);

    const theme = useTheme();
    const [userObj, setUser] = useState(null);

    // const [state, dispatch] = useReducer(menus, );
    const dispatch = useDispatch();



    function loadProfile() {
        UserService.getUserProfile()
            .then((response) => response.data)
            .then((data) => setUser(data))
            .then((data) => setIsLoading(false))
            .catch((error) => console.log(error));
    }



    useEffect(() => {
        dispatch({ type: 'PROFILE' })
        if (isLoading) {
            loadProfile();
        }
    }, []);

    useEffect(() => {
        return () => {
            dispatch({ type: '' })
        }
    }, [])



    return (
        <Page title="Profile">
            <Container >
                <Typography variant="h4" sx={{ mb: 5 }}>
                    Profile
                </Typography>

                <Grid container spacing={3}>
                    <UserProfileForm user={userObj} component={'span'}></UserProfileForm>

                </Grid>
            </Container>
        </Page>
    );

}
